module.exports = __webpack_public_path__ + "media/4_2.f66610b8.wav";